import info from "./info";
import ppr from "./ppr";

export default {
  info: info,
  ppr: ppr,
};
